import { handleActions } from 'redux-actions';

export default handleActions({
  LOAD_MODAL: (state, { payload }) => payload,
}, '');



// WEBPACK FOOTER //
// ./src/reducer/modal.js